import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { SET_GUEST_EMAIL } from '../queries/cart';

const useSetGuestEmailOnCart = () => {
  const client = useApolloClient();

  return useCallback(email => {
    return client.mutate({
      mutation: SET_GUEST_EMAIL,
      variables: {
        input: { email },
      },
    });
  }, []);
};

export default useSetGuestEmailOnCart;
